(() => {
  'use strict';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const init = () => document.querySelectorAll('.brand-roll').forEach(roll => {
    if (roll.dataset.ready) return;
    roll.dataset.ready = 'true';
    let last = scrollY, distance = 0, direction = 0, rolledDirection = 0, lastRoll = 0, animation;
    const onScroll = () => {
      if (!roll.isConnected) { removeEventListener('scroll', onScroll); return; }
      const delta = scrollY - last; last = scrollY;
      if (!delta || motion.matches || document.hidden || document.querySelector('dialog[open]')) return;
      const nextDirection = Math.sign(delta);
      if (nextDirection !== direction) { direction = nextDirection; distance = 0; }
      distance += Math.abs(delta);
      if (distance < 72 || direction === rolledDirection || performance.now() - lastRoll < 700) return;
      distance = 0; rolledDirection = direction; lastRoll = performance.now();
      animation?.cancel();
      animation = roll.animate([
        { transform: 'translateY(-33.333333%)' },
        { transform: direction > 0 ? 'translateY(-66.666667%)' : 'translateY(0%)' }
      ], { duration: 680, easing: 'cubic-bezier(.22,1,.36,1)' });
    };
    addEventListener('scroll', onScroll, { passive: true });
    motion.addEventListener('change', () => animation?.cancel());
  });
  init(); document.addEventListener('shopify:section:load', init);
})();
